import { HeaderUserMenu } from '../header-menus/header-user-menu';
import { useAuth } from 'features/auth/contexts/auth';
import { toAbsoluteUrl } from 'utils/assets';

const AsideFooter = () => {
  const { currentUser } = useAuth();
  return (
    <div className="aside-footer d-flex flex-column align-items-center flex-column-auto" id="kt_aside_footer">
      {/* begin::User */}
      <div className="d-flex align-items-center mb-10" id="kt_header_user_menu_toggle">
        {/* begin::Menu wrapper */}
        <div
          className="cursor-pointer symbol symbol-40px"
          data-kt-menu-trigger="click"
          data-kt-menu-overflow="false"
          data-kt-menu-placement="top-start"
          title="User profile"
        >
          <img src={currentUser?.photoUrl ?? toAbsoluteUrl('/media/avatars/blank.png')} alt="avatar" />
        </div>
        {/* end::Menu wrapper */}
        <HeaderUserMenu />
      </div>
      {/* end::User */}
    </div>
  );
};

export { AsideFooter };
